import Carousel from './Carousel';

const els = document.querySelectorAll('.carousel');

for (let el of els) {
    new Carousel(el);
};
